import { Box, BoxProps } from "@mui/material";
import styles from "./MainWrapper.module.scss";

export const MainWrapper = (props: BoxProps) => {
  return (
    <Box {...props} className={`${styles.mainWrapper} ${props.className}`} />
  );
};
